module.exports = __webpack_public_path__ + "img/1.f62a24f7.jpg";